import {DraggableListProps} from './DraggableListTypes';

function DraggableList({foo}: DraggableListProps) {
    console.log(foo);
    return null;
}

export default DraggableList;
